// src/pages/imamMahdi/SignsReappearance.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const SignsReappearance = () => {
  return (
    <>
      <Helmet>
        <title>Signs of Imam Mahdi’s Reappearance | Ziyarat Guide</title>
        <meta
          name="description"
          content="Learn the major and minor signs of Imam Mahdi’s (ajtf) reappearance — based on authentic hadith, focusing on readiness, faith, and justice."
        />
        <meta property="og:title" content="Signs of Imam Mahdi’s Reappearance | Ziyarat Guide" />
        <meta
          property="og:description"
          content="Discover prophetic signs before Imam Mahdi’s (ajtf) return — from global unrest to spiritual awakening, as mentioned in authentic narrations."
        />
        <meta
          property="og:image"
          content="https://ziyaratguide.com/wp-content/uploads/2025/08/third-His-role-as-the-ultimate-reformer-.png"
        />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="imam-page">
        <div className="imam-content">
          <h1 className="page-title">Signs of Imam Mahdi’s Reappearance</h1>

          <div className="content-section">
            <img
              src="https://ziyaratguide.com/wp-content/uploads/2025/08/third-His-role-as-the-ultimate-reformer-.png"
              alt="Signs of Imam Mahdi's Reappearance"
              className="imam-image"
            />

            <h2>Before His Appearance</h2>
            <ul>
              <li>Widespread oppression, people crying for justice</li>
              <li>Collapse of corrupt powers, global instability</li>
              <li>Loss of trust in leadership</li>
            </ul>

            <h2>Specific Events in Hadith</h2>
            <ul>
              <li>Sufyani uprising in Syria — a tyrant who spreads corruption</li>
              <li>Yamani uprising from Yemen — a righteous caller to truth</li>
              <li>The heavenly cry — a voice heard by all announcing the Mahdi</li>
              <li>The killing of the pure soul (Nafs Zakiyya) near the Kaaba</li>
              <li>A sun-like light in the east</li>
            </ul>

            <h2>Natural & Social Conditions</h2>
            <ul>
              <li>Lands swallowing armies (earthquakes or splits)</li>
              <li>Unprecedented deaths, fear, wars</li>
              <li>Many false claimants appearing</li>
            </ul>

            <h2>What to Emphasize</h2>
            <p>
              These signs are not for exact prediction — the Imams said many signs will only be clear in
              hindsight. The emphasis is on readiness every day, since “he who waits while preparing is as
              if fighting alongside him.”
            </p>
          </div>
        </div>

        {/* Sidebar Navigation */}
        <aside className="imam-sidebar">
          <h2>Explore More</h2>
          <ul>
            <li><Link to="/imam-mahdi">Who is Imam Mahdi?</Link></li>
            <li><Link to="/imam-mahdi/described-in-quran-hadith">Described In Quran & Hadith</Link></li>
            <li><Link to="/imam-mahdi/how-to-talk">How To Talk</Link></li>
            <li><Link to="/imam-mahdi/impact-appearance">Impact of His Appearance</Link></li>
            <li><Link to="/imam-mahdi/misconceptions">Misconceptions</Link></li>
            <li><Link to="/imam-mahdi/practices-allegiance">Practices & Allegiance</Link></li>
            <li><Link to="/imam-mahdi/reflections-stories">Reflections & Stories</Link></li>
            <li><Link to="/imam-mahdi/return">Return</Link></li>
            <li><Link to="/imam-mahdi/signs-reappearance">Signs of Reappearance</Link></li>
            <li><Link to="/imam-mahdi/supporters">Supporters</Link></li>
            <li><Link to="/imam-mahdi/ultimate-reformer">The Ultimate Reformer</Link></li>
            <li><Link to="/imam-mahdi/why-occultation">Why Occultation</Link></li>
          </ul>
        </aside>
      </div>
    </>
  );
};

export default SignsReappearance;
